import { render, staticRenderFns } from "./template/index.html?vue&type=template&id=0944ac7c&external"
import script from "./Wall.vue?vue&type=script&lang=js"
export * from "./Wall.vue?vue&type=script&lang=js"
import style0 from "./Wall.vue?vue&type=style&index=0&id=0944ac7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports